import * as React from "react";
const SvgFiRrCitrusSlice = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-citrus-slice_svg__a)">
      <path
        fill="#062147"
        d="M21.932 1.787a3.65 3.65 0 0 0-2.71-1.759 3.73 3.73 0 0 0-3.108 1.066L1.095 16.113a3.72 3.72 0 0 0-1.066 3.11 3.66 3.66 0 0 0 1.76 2.709 14.64 14.64 0 0 0 7.518 2.077c3.796 0 7.555-1.474 10.391-4.311a14.67 14.67 0 0 0 2.234-17.91m-2.97 15.76-7.548-7.548h10.57a12.67 12.67 0 0 1-3.023 7.548M10 11.414l7.547 7.547A12.67 12.67 0 0 1 10 21.984zm7.527-8.906A1.73 1.73 0 0 1 18.757 2c.773 0 1.192.37 1.458.814A12.6 12.6 0 0 1 21.935 8h-9.898zM2.014 18.977a1.73 1.73 0 0 1 .496-1.45l5.491-5.491v9.897a12.6 12.6 0 0 1-5.186-1.72 1.67 1.67 0 0 1-.8-1.238z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-citrus-slice_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCitrusSlice;
